import type { StorageAdapter, StorageHealthSnapshot } from '../interfaces/storage.js';

export function createWebStorageAdapter(initial?: StorageHealthSnapshot): StorageAdapter {
  let health: StorageHealthSnapshot = initial ?? {
    available: typeof indexedDB !== 'undefined',
    degraded: false,
  };

  return {
    get health() {
      return health;
    },

    async probe(): Promise<StorageHealthSnapshot> {
      if (typeof indexedDB === 'undefined') {
        health = {
          available: false,
          degraded: true,
          message: 'IndexedDB is unavailable in this environment.',
        };
        return health;
      }

      health = {
        available: true,
        degraded: false,
      };
      return health;
    },
  };
}
